<template>
  <div class="error-404">We are sorry, but the page you requested was not found</div>
</template>
<script>
export default {}
</script>

<style scoped lang="scss">
.error-404 {
  margin: 100px auto;
  color: black;
  text-align: center;
  padding: 50px;
  font-size: 20px;
}
</style>
